<template>
    <div style="background: #F6F6F6;">
        <van-pull-refresh v-model="isInfoLoading" @refresh="onRefresh"
                          pulling-text="Se puede actualizar desplegando..."
                          loosing-text="Se puede actualizar liberando..."
                          loading-text="En carga..."
        >
        <div class="audithome_wrap">
            <div class="audithome_head">
                <div class="audithome_hleft">Superapoyomax</div>
                <div class="audithome_hright">
                    <div class="audithome_hrimg" @click.stop="onHomeCenter">
                        <!--<img src="../../assets/img/audithome_icon01.png" />-->
                    </div>
                    <div class="audithome_hrimg" @click.stop="onHomeMenus">
                        <!--<img src="../../assets/img/audithome_icon02.png" />-->
                    </div>
                </div>
            </div>
            <div class="audithome_tps">
                <van-notice-bar scrollable text="Desde 2020 hasta el presente, los usuarios acumulados de Superapoyomax: 5 milliones de personas, y el monto del préstamo acumulado es de 10 billiones." />
            </div>
        </div>

        <div id="kychome">
            <div class="audithome_cont">
                <div class="audithome_cview">
                    <div class="auditpass_wrap">

                        <div class="mobhome_onewrap">
                            <div class="mobhome_twoview">
                                <div class="mobhome_tview">
                                    <div class="kychome_slider_title">Monto del préstamo</div>
                                    <div class="eshoy_slider_cont mobhome_tview_slider">
                                        <div class="loan-content-box">
                                            <div class="moneybox">
                                                $<span id="money">{{ dealNumber(sliderValue) }}</span>
                                            </div>
                                            <div style="display: flex; align-items: center;">
                                                <van-icon name="arrow" size="24"/>
                                            </div>
                                        </div>

                                        <div class="eshoy_slider_btns">
                                            <!--<div class="eshoy_slider_btn_view animate__animated animate__infinite animate__pulse" @click="onHomeConfirm">-->
                                            <div class="eshoy_slider_btn_view" @click="onHomeConfirm">
                                                <van-button color="linear-gradient(to top, #0F9F52, #2DDD7F)" block style="height: 1.111111rem; border-radius: 8px;">
                                                    <span style="font-weight: 500;">Solicitar</span>
                                                </van-button>
                                            </div>

                                            <div class="eshoy_slider_btn_label">
                                                <img src="../../assets/img/eshoy_slider_btn_label.png" alt="">
                                            </div>
                                        </div>

                                        <div class="kychome_slider_title_one" style="display: flex; align-items: center;">
                                            <div style="height: 50px; box-sizing: border-box; padding-left: 16px; display: flex; align-items: center;">
                                                <van-checkbox v-model="isChecked">
                                                    <template #icon>
                                                        <img
                                                                v-if="isChecked"
                                                                src="../../assets/img/contrato_ischeck.webp"
                                                                alt=""
                                                        />
                                                        <img v-else src="../../assets/mobimg/contrato_nocheck.webp" alt="" />
                                                    </template>
                                                    <template #default> He leído y acepto la <span style="color: #19A95C; text-decoration: underline;">plitica de priyacidad</span></template>
                                                </van-checkbox>
                                            </div>
                                        </div>
                                        <div class="kychome_slider_title_two"><span style="color: #999999;">Plazo:</span>91 días</div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="auditcommon_cont">
            <div class="auditcommon_one">
                <img src="../../assets/img/ocr_tips.png" />
            </div>
            <div class="auditcommon_two">
                <!--<video
                        width="100%"
                        muted
                        loop
                        autoplay="autoplay"
                        controls
                        src="./video/test3.mov"
                ></video>-->
            </div>
            <div class="auditcommon_thr" style="margin-bottom: 50px;">
                <img src="../../assets/img/homefooter_icon05.jpg" />
            </div>
        </div>

        <van-tabbar v-model="tabactive" active-color="#19A95C" inactive-color="#999999" @change="onTabChange">
            <van-tabbar-item icon="wap-home">Inicio</van-tabbar-item>
            <van-tabbar-item icon="contact">Yo</van-tabbar-item>
        </van-tabbar>
        </van-pull-refresh>
    </div>
</template>

<script type="text/javascript">

    import axios from 'axios'
    import { getTimezoneName, getUserIp } from '@/utils/commonParams';
    import { loadingShow, loadingHide } from '@/utils/loading'
    import { getAccessToken } from '@/utils/auth';

    import { getAccountInfo } from '@/api/apply';
    import { getLoanInfo, createOrder, confirmOrder, getProductinfo } from '@/api/loan'

    import { Toast } from 'vant';
    import $ from 'jquery';
    let apiHead = '';

    export default{
        data() {
            return {
                tabactive: 0,
                isChecked: true,
                isFalse: false,
                time: null,
                format: 'HH:mm:ss',
                changeNum: 50,
                sliderValue: 20000,
                account_status: null,
                homelook: 'isopen',
                isWarn: false,
                mobile: null,
                isInfoLoading: false,
                current_stage: null,
                orderStatusNor: null,
            }

        },
        mounted() {
            this.countDown();
            let login_token = window.localStorage.getItem('login_token');

            let account_status = window.localStorage.getItem('account_status');

            if(login_token && account_status == '1'){
                this.account_status = true
            } else {
                this.account_status = false
            }

            let _this = this;

            setTimeout(() => {
                client.record("login").then((r) => {
                    console.log(r);
                    //localStorage.setItem("tokenKey", r);
                    _this.$store.commit('common/SET_TOKEN_KEY', r)
                });
            }, 10);

            //this.getAccountInfo();
            this.gotoStatus();

        },
        methods: {
            onRefresh() {
                this.isInfoLoading = true;
                //this.getAccountInfo();
                this.gotoStatus();
            },
            onTabChange(item) {
                if(item == 0){
                    this.$router.replace({
                        path: '/loanpage/applyhome'
                    })
                } else if(item == 1){
                    this.$router.push({
                        path: '/loanpage/usercenter'
                    })
                }
            },
            gotoLogin() {
                this.$router.push({
                    path: '/loanpage/applywork'
                })
            },
            getHomeUrlParams() {
                let homeurl = window.location.href;
                let homeurlParamsStr = null;

                if(homeurl && homeurl.length){
                    let homeurlArr = [];
                    homeurlArr = homeurl.split('?');
                    console.log(homeurlArr)

                    if(homeurlArr.length == 2){
                        homeurlParamsStr = homeurlArr[1]

                        console.log(homeurlParamsStr)
                    }
                }

                return homeurlParamsStr;
            },
            onAppLoadClose() {
                console.log('1111')
                window.localStorage.setItem('homelook', 'isclose');
                this.homelook = 'isclose';
            },
            async getAccountInfo() {
                console.log('前往登录')
                const login_token = getAccessToken();
                console.log(login_token)
                if(login_token){ //已经登录
                    console.log('已登录11111')
                    let time_zone = getTimezoneName();
                    console.log(time_zone);
                    loadingShow();
                    let ip = await getUserIp()
                    console.log(ip)

                    let postData = {
                        zzm_yya_hqb: getAccessToken(),
                        aaa_off_csl: '111',
                    };

                    loadingShow();
                    getAccountInfo(postData, {
                        'bwd-irh-lnf': time_zone,
                        'xfo-plp-van': ip
                    }).then(res => {
                        console.log(res)
                        this.isInfoLoading = false;
                        if(res.ci == 200){
                            let useData = res.da;
                            console.log(JSON.parse(useData))
                            if(useData){
                                let useDataJSON = JSON.parse(useData);
                                let { bqr_rle_jto } = useDataJSON;

                                this.current_stage = bqr_rle_jto;

                                let orderStatus = this.orderStatus;

                                let isReloan = this.isReloan;

                                this.pageGoto(bqr_rle_jto, orderStatus, isReloan);

                            }
                        } else {
                            Toast(res.ms);
                        }
                    }, error => {
                        this.isInfoLoading = false;
                        loadingHide()
                    });


                } else { //未登录
                    console.log('未登录1111')
                    this.$router.replace({
                        path: '/loanpage/loginhome'
                    })
                    //this.gotoLogin();
                }
            },
            onCheckTokenKey(current_stage) {
                let tokenKey = this.$store.state.common.tokenKey;

                if(tokenKey && tokenKey.length > 0){
                    this.getProductListApi(tokenKey, current_stage);
                } else {
                    let _this = this;
                    setTimeout(() => {
                        client.record("login").then((r) => {
                            console.log(r);
                            //localStorage.setItem("tokenKey", r);
                            _this.$store.commit('common/SET_TOKEN_KEY', r);
                            _this.getProductListApi(r, current_stage);
                        });
                    }, 10);
                }
            },
            async getProductListApi(tokenKey, current_stage) {
                let _this = this;
                const login_token = getAccessToken();
                console.log(login_token)
                if(login_token){ //已经登录
                    console.log('已登录11111')
                    let time_zone = getTimezoneName();
                    console.log(time_zone);
                    loadingShow();
                    let ip = await getUserIp()
                    console.log(ip)

                    let postData = {
                        zzm_yya_hqb: getAccessToken(),
                        aaa_off_csl: '111',
                    };

                    loadingShow();
                    getProductinfo(postData, {
                        'bwd-irh-lnf': time_zone,
                        'xfo-plp-van': ip
                    }).then(res => {
                        console.log(res)
                        this.isProductLoading = false;
                        if(res.ci == 200){
                            let useData = res.da;
                            console.log(JSON.parse(useData))
                            if(useData){
                                let useDataJSON = JSON.parse(useData);

                                let { dts_uvj_plp } = useDataJSON;
                                if(dts_uvj_plp && dts_uvj_plp.length){
                                    //this.productInfo = dts_uvj_plp[0];
                                    console.log(dts_uvj_plp[0])
                                    this.onCreateOrder(dts_uvj_plp[0],current_stage );
                                } else {
                                    loadingHide()
                                    Toast('未获取到产品')
                                }
                            } else {
                                loadingHide()
                            }
                        } else {
                            loadingHide()
                            Toast(res.ms);
                        }
                    }, error => {
                        loadingHide()
                        this.isProductLoading = false;
                    });
                } else { //未登录
                    this.$router.replace({
                        path: '/loanpage/loginhome'
                    })
                }
            },
            async onCreateOrder(productInfo, current_stage) {
                let _this = this;
                const login_token = getAccessToken();
                console.log(login_token)
                if(login_token){ //已经登录
                    console.log('已登录11111')
                    let time_zone = getTimezoneName();
                    console.log(time_zone);
                    loadingShow();
                    let ip = await getUserIp()
                    console.log(ip)

                    let postData = {
                        zzm_yya_hqb: getAccessToken(),
                        aaa_off_csl: '111',
                        llg_pys_mii: '1',
                        lck_olj_vmv: String(productInfo.mir_env_pfp),
                        sas_dsz_vuf: String(productInfo.uyo_mbc_sie),
                        oti_fmd_qms: productInfo.id_str,
                        // lck_olj_vmv: '200',
                        // sas_dsz_vuf: '7',
                        // oti_fmd_qms: '2013078303100007002',
                    };

                    loadingShow();
                    createOrder(postData, {
                        'bwd-irh-lnf': time_zone,
                        'xfo-plp-van': ip
                    }).then(res => {
                        console.log(res)
                        //loadingHide()
                        if(res.ci == 200){
                            let useData = res.da;
                            console.log(JSON.parse(useData))
                            if(useData){
                                let useDataJSON = JSON.parse(useData);
                                if(useDataJSON){
                                    this.$store.commit('common/SET_PRODUCT_ID', productInfo.id_str);

                                    let bqr_rle_jto = current_stage;

                                    if(bqr_rle_jto == 8001){
                                        loadingHide()
                                        this.$router.push({
                                            path: '/loanpage/applywork'
                                        })
                                    } else if(bqr_rle_jto == 8002){
                                        loadingHide()
                                        this.$router.push({
                                            path: '/loanpage/applycontacts'
                                        })
                                    } else if(bqr_rle_jto == 8004){
                                        loadingHide()
                                        this.$router.push({
                                            path: '/loanpage/applyperson'
                                        })
                                    } else if(bqr_rle_jto == 8005){
                                        loadingHide()
                                        this.$router.push({
                                            path: '/loanpage/applyidcard'
                                        })
                                    } else if(bqr_rle_jto == 8006){
                                        loadingHide()
                                        this.$router.push({
                                            path: '/loanpage/livingverify',
                                            query: {
                                                isreloan: 0,
                                            }
                                        })
                                    } else if(bqr_rle_jto == 8010){
                                        loadingHide()
                                        this.$router.push({
                                            path: '/loanpage/applybank'
                                        })
                                    } else if(bqr_rle_jto == 7106){
                                        loadingHide()
                                        this.$router.push({
                                            path: '/loanpage/livingverify',
                                            query: {
                                                isreloan: 0,
                                            }
                                        })
                                    } else if(bqr_rle_jto == 8110){
                                        this.onConfirmTokenKey();
                                    }
                                }
                            } else {
                                loadingHide()
                            }
                        } else {
                            Toast(res.ms);
                        }
                    }, error => {
                        loadingHide()
                    });
                } else { //未登录
                    this.$router.replace({
                        path: '/loanpage/loginhome'
                    })
                }
            },
            onConfirmTokenKey() {
                let tokenKey = this.$store.state.common.tokenKey;

                if(tokenKey && tokenKey.length > 0){
                    this.onConfirmOrder(tokenKey);
                } else {
                    let _this = this;
                    setTimeout(() => {
                        client.record("login").then((r) => {
                            console.log(r);
                            //localStorage.setItem("tokenKey", r);
                            _this.$store.commit('common/SET_TOKEN_KEY', r);
                            _this.onConfirmOrder(r);
                        });
                    }, 10);
                }
            },
            async onConfirmOrder(tokenKey) {
                let _this = this;
                const login_token = getAccessToken();
                console.log(login_token)
                if(login_token){ //已经登录
                    console.log('已登录11111')
                    let time_zone = getTimezoneName();
                    console.log(time_zone);
                    loadingShow();
                    let ip = await getUserIp()
                    console.log(ip)

                    let postData = {
                        zzm_yya_hqb: getAccessToken(),
                        aaa_off_csl: '111',
                        vjk_fjt_bvh: tokenKey,
                        bpb_imu_jqa: '',
                        fkc_cmc_zbn: '',
                        doe_ody_zty: '',
                    };

                    loadingShow();
                    confirmOrder(postData, {
                        'bwd-irh-lnf': time_zone,
                        'xfo-plp-van': ip
                    }).then(res => {
                        console.log(res)
                        if(res.ci == 200){
                            let useData = res.da;
                            console.log(JSON.parse(useData))
                            if(useData){
                                let useDataJSON = JSON.parse(useData);
                                if(useDataJSON){
                                    //let { bqr_rle_jto } = useDataJSON;
                                    setTimeout(() => {
                                        loadingHide();
                                        this.$router.replace({
                                            path: '/loanpage/loanstatus'
                                        })
                                    }, 1000)
                                }
                            }
                        } else {
                            Toast(res.ms);
                        }
                    }, error => {
                        loadingHide()
                    });
                } else { //未登录
                    this.$router.replace({
                        path: '/loanpage/loginhome'
                    })
                }
            },
            applyStatus(current_stage, isReloan) {
                if(current_stage){
                    let bqr_rle_jto = current_stage;

                    if(bqr_rle_jto == 7015){
                        loadingHide()
                        this.$router.push({
                            path: '/loanpage/reapeatloan'
                        })
                    } else if(bqr_rle_jto == 8110){
                        if(isReloan == 1){
                            loadingHide()
                            this.$router.push({
                                path: '/loanpage/reapeatloan'
                            });
                        } else {
                            this.onCheckTokenKey(current_stage);
                        }
                    } else {
                        if(isReloan == 1){
                            if(current_stage == 7106 || current_stage == 8006){
                                loadingHide()
                                this.$router.push({
                                    path: '/loanpage/livingverify',
                                    query: {
                                        isreloan: 1,
                                    }
                                })
                            } else {
                                loadingHide()
                                this.$router.push({
                                    path: '/loanpage/reapeatloan'
                                });
                            }
                        } else {
                            this.onCheckTokenKey(current_stage);
                        }
                    }
                }
            },
            pageGoto(current_stage, orderStatus, isReloan){

                console.log('current_stage--' + current_stage)
                console.log('orderStatus--' + orderStatus)
                console.log('isReloan--' + isReloan)

                if(orderStatus == 2){ //需要检测进件状态
                    let orderStatusNor = this.orderStatusNor;
                    if(orderStatusNor == 22){
                        this.$router.push({
                            path: '/loanpage/firstloan'
                        });
                    } else {
                        this.applyStatus(current_stage, isReloan);
                    }
                } else if(orderStatus == 3){ //去还款
                    loadingHide()
                    this.$router.push({
                        path: '/loanpage/repayment'
                    });
                } else if(orderStatus == 1){ //等待状态不需要进件
                    loadingHide()
                    let orderStatusNor = this.orderStatusNor;
                    if(orderStatusNor == 22){

                        this.$router.push({
                            path: '/loanpage/firstloan'
                        });

                    } else {
                        let loanStatus = this.loanStatus;

                        if(loanStatus == 1 || loanStatus == 2 || loanStatus == 3 || loanStatus == 4){
                            this.$router.push({
                                path: '/loanpage/loanstatus'
                            });
                        } else {
                            if(this.isReloan == 1){
                                    this.$router.push({
                                        path: '/loanpage/reapeatloan'
                                    });
                            } else {
                                    this.$router.push({
                                        path: '/loanpage/firstloan'
                                    });
                            }
                        }
                    }
                }
            },
            async onHomeConfirm() {
                this.getAccountInfo();
            },
            async gotoStatus() {
                let _this = this;
                const login_token = getAccessToken();
                console.log(login_token)
                if(login_token){ //已经登录
                    console.log('已登录11111')
                    let time_zone = getTimezoneName();
                    console.log(time_zone);
                    loadingShow();
                    let ip = await getUserIp()
                    console.log(ip)

                    let postData = {
                        zzm_yya_hqb: getAccessToken(),
                        aaa_off_csl: '111',
                    };

                    loadingShow();
                    getLoanInfo(postData, {
                        'bwd-irh-lnf': time_zone,
                        'xfo-plp-van': ip
                    }).then(res => {
                        console.log(res)
                        loadingHide()
                        this.isInfoLoading = false;
                        if(res.ci == 200){
                            let useData = res.da;
                            console.log(JSON.parse(useData))
                            if(useData){
                                let useDataJSON = JSON.parse(useData);
                                let {vkt_fnd_yzo, ojq_dzg_oxq } = useDataJSON;
                                //order_status, reapply_time, server_time current_is_reloan,
                                let { omi_fje_qly, huw_kdq_nxo, xhi_cur_ovl } = vkt_fnd_yzo;

                                console.log(omi_fje_qly);
                                console.log(huw_kdq_nxo);
                                console.log(ojq_dzg_oxq);
                                console.log(xhi_cur_ovl);

                                this.orderStatusNor = omi_fje_qly;
                                this.getStatus(omi_fje_qly, huw_kdq_nxo, ojq_dzg_oxq, xhi_cur_ovl, _this);

                            }
                        } else {
                            Toast(res.ms);
                        }
                    }, error => {
                        loadingHide()
                        this.isInfoLoading = false;
                    });
                } else { //未登录
                    console.log('未登录1111')
                    this.$router.replace({
                        path: '/loanpage/loginhome'
                    })
                    //this.gotoLogin();
                }
            },
            getStatus: (value, reapply_time, server_time, current_is_reloan, _this) => {
                switch (value) {
                    case 0:
                    case 10:
                    case 15:
                    case 17:
                    case 21:
                        console.log('0没有申请过,10失效,15展期结清,17展期失效,21等待签约');
                        _this.orderStatus = 2;
                        if(current_is_reloan != undefined){
                            if(current_is_reloan == 1){
                                _this.isReloan = 1;
                            } else {
                                _this.isReloan = null;
                            }
                        } else {
                            _this.isReloan = null;
                        }

                        /*if(_this.isReloan == 1){
                            _this.$router.push({
                                path: '/loanpage/reapeatloan'
                            });
                        } else {
                            _this.$router.push({
                                path: '/loanpage/firstloan'
                            });
                        }*/
                        break;
                    case 1:
                    case 2:
                    case 4:
                    case 13:
                    case 18:
                    case 19:
                    case 20:
                        console.log('//1提交申请,2提交审核,4等待人工审核,13等待第三方黑名单验证,18等待自动外呼,19等待人脸对比,20人工审核质检中');
                        _this.orderStatus = 1;
                        _this.loanStatus = 1;
                        /*_this.$router.push({
                            path: '/loanpage/loanstatus'
                        });*/
                        break;
                    case 3:
                        console.log('//审核拒绝');
                        if (_this.canReloanByTime(reapply_time, server_time)) {
                            _this.orderStatus = 2;
                            if (_this.isReloan) {
                                if(current_is_reloan != undefined){
                                    if(current_is_reloan == 1){
                                        _this.isReloan = 1;
                                    } else {
                                        _this.isReloan = 1;
                                    }
                                } else {
                                    _this.isReloan = 1;
                                }
                                /*_this.$router.push({
                                    path: '/loanpage/reapeatloan'
                                });*/
                            } else {
                                if(current_is_reloan != undefined){
                                    if(current_is_reloan == 1){
                                        _this.isReloan = 1;
                                    } else {
                                        _this.isReloan = null;
                                    }
                                } else {
                                    _this.isReloan = null;
                                }

                                /*if(_this.isReloan == 1){
                                    _this.$router.push({
                                        path: '/loanpage/reapeatloan'
                                    });
                                } else {
                                    _this.$router.push({
                                        path: '/loanpage/firstloan'
                                    });
                                }*/
                            }
                        } else {
                            _this.orderStatus = 1;
                            _this.loanStatus = 2;

                            /*if(_this.isReloan == 1){
                                _this.$router.push({
                                    path: '/loanpage/reapeatloan'
                                });
                            } else {
                                _this.$router.push({
                                    path: '/loanpage/firstloan'
                                });
                            }*/
                        }
                        break;
                    case 5:
                    case 12:
                        console.log('//5等待放款，12正在放款中');
                        _this.orderStatus = 1;
                        _this.loanStatus = 3;

                        /*_this.$router.push({
                            path: '/loanpage/loanstatus'
                        });*/
                        break;
                    case 6:
                        console.log('//放款失败');
                        _this.orderStatus = 1;
                        _this.loanStatus = 4;

                        /*_this.$router.push({
                            path: '/loanpage/loanstatus'
                        });*/
                        break;
                    case 7:
                    case 9:
                    case 11:
                    case 14:
                    case 16:
                        console.log('7等待还款，9逾期，11部分还款，14等待展期，16展期申请中');
                        _this.orderStatus = 3;

                        /*_this.$router.push({
                            path: '/loanpage/repayment'
                        });*/
                        break;
                    case 8:
                        console.log('8已结清');
                        _this.orderStatus = 2;
                        if(current_is_reloan != undefined){
                            if(current_is_reloan == 1){
                                _this.isReloan = 1;
                            } else {
                                _this.isReloan = 1;
                            }
                        } else {
                            _this.isReloan = 1;
                        }
                        /*_this.$router.push({
                            path: '/loanpage/reapeatloan'
                        });*/
                        break;
                    case 22:
                        console.log('22等待订单再次确认');
                        _this.orderStatus = 2;
                        if(current_is_reloan != undefined){
                            if(current_is_reloan == 1){
                                _this.isReloan = 1;
                            } else {
                                _this.isReloan = 0;
                            }
                        } else {
                            _this.isReloan = 0;
                        }

                        /*_this.$router.push({
                            path: '/loanpage/confirmloan'
                        });*/
                        break;
                    default:
                        _this.orderStatus = 2;
                        if(current_is_reloan != undefined){
                            if(current_is_reloan == 1){
                                _this.isReloan = 1;
                            } else {
                                _this.isReloan = null;
                            }
                        } else {
                            _this.isReloan = null;
                        }

                        /*if(_this.isReloan == 1){
                            _this.$router.push({
                                path: '/loanpage/reapeatloan'
                            });
                        } else {
                            _this.$router.push({
                                path: '/loanpage/firstloan'
                            });
                        }*/
                }
            },
            canReloanByTime(repTime, stime) {
                return repTime < stime;
            },
            /*async accountInfo() {
                console.log('前往登录')
                const login_token = getAccessToken();
                console.log(login_token)
                if(login_token){ //已经登录
                    console.log('已登录11111')
                    let time_zone = getTimezoneName();
                    console.log(time_zone);
                    loadingShow();
                    let ip = await getUserIp()
                    console.log(ip)

                    let postData = {
                        zzm_yya_hqb: getAccessToken(),
                        aaa_off_csl: '111',
                    };

                    loadingShow();
                    getAccountInfo(postData, {
                        'bwd-irh-lnf': time_zone,
                        'xfo-plp-van': ip
                    }).then(res => {
                        console.log(res)
                        loadingHide()
                        if(res.ci == 200){
                            let useData = res.da;
                            console.log(JSON.parse(useData))
                            if(useData){
                                let useDataJSON = JSON.parse(useData);
                                let { bqr_rle_jto } = useDataJSON;
                                // 1001 工作信息
                                // 1002 联系人信息
                                // 1004 个人信息
                                // 1005 身份信息
                                // 1006 活体认证
                                // 1010 绑定银行卡


                                /!*1001 //工作信息
                                 1002 //联系人信息
                                 1003 //其他信息
                                 1004 //个人信息
                                 1005 //身份信息
                                 1006 //活体认证
                                 1007 //其他授信
                                 1008 // NIP认证
                                 1009 // NIP2认证
                                 1110 //完成借贷流程

                                 1010                            // 绑定银行卡独立接口
                                 1011                            // 跳过绑定银行卡
                                 1012                            // 导流用户第一次走工作简化流程

                                 DefaultLoanFlow                 string = "1001,1002,1004,1005,1006,1010" // 默认的借款流程配置*!/

                                if(bqr_rle_jto == 8001){
                                    this.$router.push({
                                        path: '/loanpage/applywork'
                                    })
                                } else if(bqr_rle_jto == 8002){
                                    this.$router.push({
                                        path: '/loanpage/applycontacts'
                                    })
                                } else if(bqr_rle_jto == 8004){
                                    this.$router.push({
                                        path: '/loanpage/applyperson'
                                    })
                                } else if(bqr_rle_jto == 8005){
                                    this.$router.push({
                                        path: '/loanpage/applyidcard'
                                    })
                                } else if(bqr_rle_jto == 8006){
                                    this.$router.push({
                                        path: '/loanpage/livingverify'
                                    })
                                } else if(bqr_rle_jto == 8010){
                                    this.$router.push({
                                        path: '/loanpage/applybank'
                                    })
                                } else if(bqr_rle_jto == 8110){
                                    this.$router.push({
                                        path: '/loanpage/userstate'
                                    })
                                }

                                // this.$router.replace({
                                //     path: '/loanpage/applyhome',
                                // })

                                /!*bqr_rle_jto: 8110 //current_step
                                jba_hmp_qjh: 0 //amount
                                ojq_dzg_oxq: 1750489314815 //server_time
                                swg_nuc_tnu: 0 //remaining_days*!/

                            }
                        } else {
                            Toast(res.ms);
                        }
                    }, error => {
                        loadingHide()
                    });


                } else { //未登录
                    console.log('未登录1111')
                    this.$router.replace({
                        path: '/loanpage/loginhome'
                    })
                    //this.gotoLogin();
                }
            },*/
            onCloseMeuns() {
                this.menusShow = false;
            },
            onHomeMenus() {
                //this.menusShow = true;
            },
            countDown() { // 传入时间戳
                //const d = new Date('2023-07-6').getTime()
                let d = window.localStorage.getItem('expire_time');
                if(d && d != 0){
                    const now = new Date().getTime();
                    let timeStamp = d - now;

                    console.log(timeStamp)
                    this.time = timeStamp;
                }
            },
            dealNumber(num) {
                if (num != 0 && num) {
                    num = num + "";
                    let splitList = num.split(".");
                    //将整数部分拆解为单个数字的数组倒序，然后拼装为新的数组，每3位数字进行一次匹配
                    let intStrList = splitList[0]
                        .split("")
                        .reverse()
                        .join("")
                        .match(/(\d{1,3})/g);
                    //将匹配后的数组用，拼接，再拆解为单个数字的数组，反转为原先数组形式，拼接为完整数字
                    let intStr = intStrList.join(",").split("").reverse().join("");
                    return intStr;
                }
                return num;
            },
            onHomeCenter() {
                /*let login_token = window.localStorage.getItem('login_token');
                let homeUrlParams = this.getHomeUrlParams();
                if(login_token){
                    window.location.href = './cuenta.html?' + homeUrlParams
                } else {
                    window.location.href = './loginhome.html?' + homeUrlParams
                }*/
            },
            onMobile(){
                //console.log(this.mobile)
                let getmobile = this.mobile;

                let firstStr = getmobile.substr(0, 1);

                if(firstStr == 1){ //1开始 11位

                    if(getmobile.length > 11){
                        this.mobile = getmobile.substr(0, 11);
                    }

                } else {//非1 10位
                    if(getmobile.length > 10){
                        this.mobile = getmobile.substr(0, 10);
                    }
                }
            },
            goLogin() {
                //let _this = this;
                this.isWarn = false;
                this.varSmscode = false;
                if(this.mobile){
                    let getmobile = this.mobile;

                    let firstStr = getmobile.substr(0, 1);

                    let isflag = false;

                    if(firstStr == 1){ //1开始 11位
                        if(getmobile.length == 11){
                            isflag = true;
                        } else {
                            isflag = false;
                        }

                    } else {//非1 10位
                        if(getmobile.length == 10){
                            isflag = true;
                        } else {
                            isflag = false;
                        }
                    }

                    //console.log(firstStr)

                    if(isflag){
                        console.log(1222)
                    } else {
                        Toast('Formato incorrecto del número móvil') //手机号码格式错误
                    }

                } else {
                    Toast('Por favor ingrese el número de teléfono móvil') //请输入手机号
                }
            }
        }
    }

</script>

<style scss scoped>
    .audithome_wrap{
        width: 100%;
        height: 9.861111rem;
        background: linear-gradient(180deg, #19A95C 0%, #F6F6F6 100%);
    }
    .audithome_head{
        width: 100%;
        height: 1.333333rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        padding: 0 0.444444rem;
    }
    .audithome_hleft{
        width: 5.555556rem;
        height: 0.583333rem;
        font-size: 0.5rem;
        font-weight: 500;
        color: #FFFFFF;
    }
    .audithome_hright{
        width: 1.361111rem;
        height: 0.5rem;
        display: flex;
        justify-content: space-between;
    }
    .audithome_hrimg{
        width: 0.5rem;
        height: 0.5rem;
    }
    .audithome_hrimg img{
        display: block;
        width: 0.5rem;
        height: 0.5rem;
    }
    .audithome_tps{
        width: 100%;
        height: 0.833333rem;
        box-sizing: border-box;
        /*padding: 0 0.444444rem;*/
        background: rgba(255,255,255,0.26);
        /*display: flex;*/
        /*justify-content: flex-start;*/
        /*align-items: center;*/
    }
    .audithome_tps span{
        width: 100%;
        height: 0.388889rem;
        font-size: 12px;
        font-weight: 400;
        color: #FFFFFF;
        transform: scale(0.9);
        transform-origin:0 0;
        overflow: hidden;
        white-space:nowrap;
        -o-text-overflow:ellipsis;
        text-overflow:ellipsis;
    }
    #kychome{
        /*padding-bottom: 30px;*/
    }
    #kychome .audithome_cont{
        width: 100%;
        height: 0.833333rem;
        position: relative;
    }
    #kychome  .audithome_cview{
        width: 100%;
        height: auto;
        position: absolute;
        left: 0;
        top: -7.694444rem;
    }
    #kychome  .auditpass_wrap{
        width: 100%;
        height: auto;
        position: relative;
    }
    #kychome .auditpass_bgimg{
        display: block;
        width: 100%;
    }
    #kychome .audithome_cont .auditpass_view{
        width: 100%;
        height: auto;
        position: absolute;
        left: 0;
        top: 0;
        box-sizing: border-box;
        padding-top: 4.222222rem;
    }
    #kychome .auditpass_title{
        width: 100%;
        height: 0.972222rem;
        font-size: 0.583333rem;
        font-weight: bold;
        color: #333333;
        line-height: 0.583333rem;
        text-align: center;
    }
    #kychome .auditpass_desc{
        width: 92.22%;
        height: auto;
        margin: 0 auto;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #666666;
        line-height: 0.472222rem;
        text-align: center;
    }
    #kychome .auditpass_solid_view{
        width: 100%;
        height: 0.388889rem;
        margin-top: 4.25rem;
        box-sizing: border-box;
        padding: 0 0.444444rem;
        display: flex;
        justify-content: space-between;
    }
    #kychome .auditpass_solid_middle{
        width: auto;
        height: 0.388889rem;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #19A95C;
        line-height: 0.388889rem;
    }
    #kychome .auditpass_solid_left{
        width: 2.916667rem;
        height: 0.388889rem;
        display: flex;
        align-items: center;
    }
    #kychome .auditpass_solid_left img{
        display: block;
        width: 100%;
        height: 1px;
    }
    #kychome .auditpass_solid_right{
        width: 2.916667rem;
        height: 0.388889rem;
        display: flex;
        align-items: center;
    }
    #kychome .auditpass_solid_right img{
        display: block;
        width: 100%;
        height: 1px;
    }
    #kychome .auditpass_times{
        width: 100%;
        height: 1.611111rem;
        box-sizing: border-box;
        padding-top: 0.222222rem;
    }
    #kychome .zpan_hthr_times{
        width: 28.4%;
        height: 0.694444rem;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
    }
    #kychome .zpan_hthr_titmes{
        width: 0.694444rem;
        height: 0.694444rem;
        background: #ffffff;
        border-radius: 0.083333rem;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        border: 1px solid #BCDCCA;
    }
    #kychome .zpan_hthr_titmes span{
        font-size: 0.388889rem;
        font-weight: 600;
        color: #19A95C;
    }
    #kychome .zpan_hthr_ditmes{
        width: 0.388889rem;
        height: 0.583333rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    #kychome .auditpass_btns{
        width: 92.22%;
        height: 1.222222rem;
        margin: 0 auto;
    }
    .auditcommon_cont{
        width: 100%;
        height: auto;
        box-sizing: border-box;
        padding: 0.833333rem 0.416667rem;
    }
    .auditcommon_one{
        width: 100%;
        height: 3.638889rem;
    }
    .auditcommon_oitem{
        width: 50%;
        height: 2.083333rem;
        float: left;
    }
    .auditcommon_oitem img{
        display: block;
        width: 100%;
        height: 2.083333rem;
    }
    .auditcommon_two{
        width: 100%;
        height: auto;
        border-radius: 6px;
        margin: 0.416667rem 0;
        overflow: hidden;
    }
    /*.auditcommon_two video{*/
    /*width: 100%;*/
    /*height: 4.444444rem;*/
    /*}*/
    .auditcommon_thr{
        width: 100%;
        height: auto;
    }
    .auditcommon_thr img{
        display: block;
        width: 100%;
    }

    .mobhome_onewrap{
        width: 100%;
        height: auto;
        padding-top: 0.277778rem;
    }
    .mobhome_twoview{
        width: 91.11%;
        height: 8.666667rem;
        margin: 0 auto;
        background: #ffffff;
        box-sizing: border-box;
        padding: 0.277778rem;
        border-radius: 0.222222rem;
    }
    .mobhome_tview{
        width: 100%;
        height: 100%;
        border-radius: 0.222222rem;

    }
    .mobhome_thrview{
        width: 100%;
        height: 0.916667rem;
        margin: 11px auto 0 auto;
    }
    .mobhome_thrview img{
        width: 43.47%;
        display: block;
        margin: 0 auto;
    }
    .mobhome_fivborder{
        width: 88.89%;
        padding-top: 1.916667rem;
        margin: 0 auto;
    }
    .mobfooter_wrap{
        width: 100%;
        height: auto;
        background: #0A0B0E;
        padding-top: 1.944444rem;
        padding-bottom: 1.944444rem;
    }
    .mobfooter_cont{
        width: 88.89%;
        height: auto;
        margin: 0 auto;
    }
    .mobfooter_title{
        width: 100%;
        height: 0.444444rem;
        font-size: 0.444444rem;
        font-weight: 600;
        color: #E8E8E9;
        line-height: 0.444444rem;
    }
    .mobfooter_list{
        width: 100%;
        height: auto;
        padding-top: 0.333333rem;
    }
    .mobfooter_items{
        width: 100%;
        height: 1.5rem;
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
    }
    .mobfooter_ileft{
        width: auto;
        height: 1.5rem;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #E8E8E9;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .mobfooter_ileft_active{
        color: #39CA80;
    }
    .mobfooter_iright{
        width: 0.277778rem;
        height: 1.5rem;
        display: flex;
        align-items: center;
    }
    .mobfooter_iright img{
        display: block;
        width: 100%;
        height: 0.416667rem;
    }
    .mobfooter_middle{
        width: 100%;
        height: auto;
        padding-top: 1.388889rem;
    }
    .mobfooter_mimg{
        width: 100%;
        padding-top: 0.611111rem;
    }
    .mobfooter_mimg img{
        display: block;
        width: 4.861111rem;
    }
    .mobfooter_down{
        width: 100%;
        padding-top: 1.388889rem;
    }
    .mobfooter_dlist{
        width: 100%;
        height: auto;
        padding-top: 0.333333rem;
    }
    .mobfooter_dlitem{
        width: 100%;
        height: auto;
        padding-top: 0.555556rem;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #B6B8BF;
    }
    .mobhome_tview .eshoy_slider_cont{
        width: 100%;
        background: none;
    }
    .mobhome_tview .sliderbox_wrap{
        width: 87.5%;
        margin: 0 auto;
    }
    .mobhome_tview .sliderbox_left{
        width: 16.3%;
        height: 1.194444rem;
        padding-top: 1px;
    }
    .mobhome_tview .sliderbox_middle{
        width: 66%;
    }
    .mobhome_tview .sliderbox_right{
        width: 16.3%;
        height: 1.194444rem;
        padding-top: 1px;
    }
    .mobhome_tview .sliderbox_cimg{
        width: 100%;
        height: 0.694444rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .mobhome_tview .eshoy_gold_small{
        display: block;
        width: 24px;
        height: 14px;
    }
    .mobhome_tview .eshoy_gold_more{
        display: block;
        width: 24px;
        height: 21px;
    }
    .mobhome_tview .sliderbox_ctext{
        width: 100%;
        height: 0.5rem;
        line-height: 0.5rem;
        font-size: 0.37rem;
        margin-top: 2px;
        position: relative;
    }
    .sliderbox_ctext_view{
        width: auto;
        height: 0.5rem;
        position: absolute;
        left: -0.22rem;
        top: 0;
    }
    .mobhome_tview .sliderBox{
        width: 100%;
    }
    .mobhome_tview .loan-content-box{
        width: 100%;
        height: auto;
        display: flex;
        justify-content: center;
    }
    .mobhome_tview .moneybox{
        height: 1.138889rem;
        font-size: 1.0rem;
        padding-bottom: 0.527778rem
    }
    .mobhome_tview .moneybox span {
        font-size: 1.2rem;
    }
    .mobhome_tview .sliderBox{
        margin: 0.35rem auto 0 auto;
    }
    .mobhome_tview .el-slider__bar{
        height: 0.138889rem !important;
        border-radius: 0.069444rem !important;
    }
    .mobhome_tview .el-slider__runway{
        height: 0.138889rem !important;
        border-radius: 0.069444rem !important;
    }
    .mobhome_tview .el-slider__button-wrapper{
        width: 0.972222rem !important;
        height: 0.972222rem !important;
        top: -0.388889rem !important;
    }
    .mobhome_tview .sliderbox_wrap{
        height: 1.694444rem;
    }
    .mobhome_tview .eshoy_slider_btns{
        width: 7.722222rem;
        height: 1.111111rem;
        margin-top: 1.333333rem;
    }
    .mobhome_tview .eshoy_slider_btn_view{
        width: 7.722222rem;
        height: 1.111111rem;
    }

    .moneybox {
        font-size: 0.833333rem;
        font-weight: 600;
        color: #333333;
        text-align: center;
        text-align: center;
        padding-bottom: 74px;
    }

    .moneybox span {
        font-size: 1.0rem;
    }

    .sliderBox {
        width: 546px;
        height: auto;
        background: #E4EFEB;
        border-radius: 5px;
        margin: 24px auto 0 auto;
        position: relative;
    }

    .range {
        display: none;
        justify-content: space-between;
        margin-top: 35px;
    }

    .range p {
        font-size: 16px;
        color: #666;
        font-weight: 500;
    }

    .range p span {
        font-size: 18px;
    }
    .sliderbox_wrap{
        width: 762px;
        height: 86px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
    }
    .sliderbox_left{
        width: 88px;
        height: 86px;
    }

    .sliderbox_right{
        width: 88px;
        height: 86px;
    }
    .sliderbox_cimg{
        width: 88px;
        height: 50px;
    }
    .sliderbox_ctext{
        width: 100%;
        height: 36px;
        font-size: 18px;
        font-family: MiSans-Regular, MiSans;
        font-weight: 500;
        color: #8C8480;
        line-height: 36px;
        text-align: center;
    }
    .sliderbox_ctext span{
        padding-left: 6px;
    }
    .eshoy_slider_btns{
        width: 378px;
        height: 72px;
        margin: 80px auto 0 auto;
        cursor: pointer;
        position: relative;
    }
    .eshoy_slider_btn_view{
        width: 378px;
        height: 72px;
    }
    .eshoy_slider_btns img{
        display: block;
        width: 100%;
    }
    .kychome_slider_title{
        width: 100%;
        height: 1.083333rem;
        font-size: 0.444444rem;
        font-weight: bold;
        color: #333333;
        line-height: 1.083333rem;
        text-align: center;
    }
    .kychome_slider_title_one{
        width: 100%;
        height: 0.805556rem;
        font-size: 0.444444rem;
        font-weight: 400;
        color: #666666;
        line-height: 0.527778rem;
        text-align: center;
    }
    .kychome_slider_title_two{
        width: 100%;
        height: 1.0rem;
        font-size: 0.5rem;
        font-weight: 500;
        color: #333333;
        line-height: 0.583333rem;
        text-align: center;
        margin-top: 20px;
    }
    .menus_wrap{
        width: 100%;
        height: 100vh;
        position: relative;
    }
    .menus_head{
        width: 100%;
        height: auto;
        box-sizing: border-box;
        padding: 0.833333rem 0 1.055556rem 0.694444rem;
    }
    .menus_head img{
        display: block;
        width: 1.388889rem;
        height: 1.388889rem;
    }
    .menus_footer{
        width: 100%;
        height: 2.2rem;
        background: #F6F6F6;
        border-radius: 0px 0px 0px 0.555556rem;
        position: absolute;
        left: 0;
        bottom: 0;
        box-sizing: border-box;
        padding: 0.555556rem 0 0 0.694444rem;
        display: flex;
        justify-content: flex-start;
    }
    .menus_ficon{
        width: 0.555556rem;
        height: 0.555556rem;
    }
    .menus_ficon img{
        display: block;
        width: 0.555556rem;
        height: 0.555556rem;
    }
    .menus_ftext{
        width: 1.388889rem;
        height: 0.555556rem;
        margin-left: 0.361111rem;
        font-size: 0.388889rem;
        font-weight: 500;
        color: #666666;
        line-height: 0.555556rem;
    }
    .menus_list{
        width: 100%;
        height: auto;
    }
    .menus_items{
        width: 100%;
        height: 1.305556rem;
    }
    .menus_item{
        width: 100%;
        height: 1.111111rem;
        box-sizing: border-box;
        padding-left: 0.694444rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .menus_iicon{
        width: 0.916667rem;
        height: 0.555556rem;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        padding-right: 0.361111rem;
    }
    .menus_iicon01{
        display: block;
        width: 0.555556rem;
        height: 0.5rem;
    }
    .menus_iicon02{
        display: block;
        width: 0.555556rem;
        height: 0.555556rem;
    }
    .menus_iicon03{
        display: block;
        width: 0.555556rem;
        height: 0.555556rem;
    }
    .menus_iicon04{
        display: block;
        width: 0.5rem;
        height: 0.555556rem;
    }
    .menus_itext{
        width: auto;
        height: 0.555556rem;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #333333;
        line-height: 0.555556rem;
    }
    .menus_cview{
        width: 100%;
        height: 1.861111rem;
    }
    .menus_items_active .menus_item{
        background: #19A95C;
    }
    .menus_items_active .menus_itext{
        color: #FFFFFF;
    }

    #audithome .audithome_cont{
        width: 100%;
        height: 6.861111rem;
        position: relative;
    }
    #audithome .audithome_cview{
        width: 100%;
        height: 14.555556rem;
        position: absolute;
        left: 0;
        top: -7.694444rem;
    }
    #audithome .auditpass_wrap{
        width: 100%;
        height: auto;
        position: relative;
    }
    #audithome .auditpass_bgimg{
        display: block;
        width: 100%;
    }
    #audithome .audithome_cont .auditpass_view{
        width: 100%;
        height: auto;
        position: absolute;
        left: 0;
        top: 0;
        box-sizing: border-box;
        padding-top: 4.222222rem;
    }
    #audithome .auditpass_title{
        width: 100%;
        height: 0.972222rem;
        font-size: 0.583333rem;
        font-weight: bold;
        color: #333333;
        line-height: 0.583333rem;
        text-align: center;
    }
    #audithome .auditpass_desc{
        width: 92.22%;
        height: auto;
        margin: 0 auto;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #666666;
        line-height: 0.472222rem;
        text-align: center;
    }
    #audithome .auditpass_solid_view{
        width: 100%;
        height: 0.388889rem;
        margin-top: 4.25rem;
        box-sizing: border-box;
        padding: 0 0.444444rem;
        display: flex;
        justify-content: space-between;
    }
    #audithome .auditpass_solid_middle{
        width: auto;
        height: 0.388889rem;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #19A95C;
        line-height: 0.388889rem;
    }
    #audithome .auditpass_solid_left{
        width: 2.916667rem;
        height: 0.388889rem;
        display: flex;
        align-items: center;
    }
    #audithome .auditpass_solid_left img{
        display: block;
        width: 100%;
        height: 1px;
    }
    #audithome .auditpass_solid_right{
        width: 2.916667rem;
        height: 0.388889rem;
        display: flex;
        align-items: center;
    }
    #audithome .auditpass_solid_right img{
        display: block;
        width: 100%;
        height: 1px;
    }
    #audithome .auditpass_times{
        width: 100%;
        height: 1.611111rem;
        box-sizing: border-box;
        padding-top: 0.222222rem;
    }
    #audithome .zpan_hthr_times{
        width: 28.4%;
        height: 0.694444rem;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
    }
    #audithome .zpan_hthr_titmes{
        width: 0.694444rem;
        height: 0.694444rem;
        background: #ffffff;
        border-radius: 0.083333rem;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        border: 1px solid #BCDCCA;
    }
    #audithome .zpan_hthr_titmes span{
        font-size: 0.388889rem;
        font-weight: 600;
        color: #19A95C;
    }
    #audithome .zpan_hthr_ditmes{
        width: 0.388889rem;
        height: 0.583333rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    #audithome .auditpass_btns{
        width: 92.22%;
        height: 1.222222rem;
        margin: 0 auto;
    }
    #audithome{
        padding-bottom: 30px;
    }
    .com_fc_down_wrap{
        width: 100%;
        height: 1.666667rem;
    }
    .com_fc_down{
        width: 100%;
        height: auto;
        position: fixed;
        left: 0;
        bottom: 0.444444rem;
    }
    .com_fc_dview{
        width: 100%;
        height: 1.666667rem;
        margin: 0 auto;
        position: relative;
    }
    .com_fc_dview img{
        display: block;
        width: 100%;
        height: 100%;
    }
    .com_fc_dvclose{
        width: 1.666667rem;
        height: 1.666667rem;
        position: absolute;
        top: 0;
        right: 0;
    }
    .verifycode_wrap{
        width: 100%;
        height: auto;
    }
    .verifycode_cont{
        width: 100%;
        height: auto;
        background: #FFFFFF;
        border-radius: 0.555556rem 0.555556rem 0px 0px;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding-top: 0.222222rem;
    }
    .verifycode_tilte{
        width: 1.25rem;
        height: 0.083333rem;
        background: #CFCFCF;
        border-radius: 0.083333rem;
        margin: 0 auto;
    }
    .verifycode_top{
        width: 100%;
        height: 2.583333rem;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding: 0.555556rem 0.444444rem 0 0.444444rem;
        display: flex;
        justify-content: space-between;
    }
    .verifycode_tleft{
        width: auto;
        height: 0.611111rem;
        font-size: 0.527778rem;
        font-weight: bold;
        color: #1A1A1A;
        line-height: 44px;
        display: flex;
        align-items: center;
    }
    .verifycode_tleft span{
        float: left
    }
    .verifycode_tright{
        width: 0.666667rem;
        height: 0.666667rem;
    }
    .verifycode_tright img{
        display: block;
        width: 100%;
    }
    .verifycode_form{
        width: 91.11%;
        height: 5.972222rem;
        margin: 0 auto;
    }
    .verifycode_items_scale-1px{
        position: relative;
        border:none;
    }
    .verifycode_items_scale-1px:after{
        content: '';
        position: absolute;
        bottom: 0;
        background: #E7E7E7;
        width: 100%;
        height: 1px;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
    }
    .verifycode_items{
        width: 100%;
        height: 1.444444rem;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding-top: 0.277778rem;
    }
    .verifycode_item{
        width: 100%;
        height: 1.166667rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .verifycode_ioneleft{
        width: 1.055556rem;
        height: 1.166667rem;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #1A1A1A;
        line-height: 1.166667rem;
    }
    .verifycode_ioneright{
        width: 7.777778rem;
        height: 1.166667rem;
    }
    .verifycode_ioneright input{
        display: block;
        width: 100%;
        height: 1.12rem;
        outline: none;
        border: none;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #1A1A1A;
        background: #ffffff;
        padding: 0;
    }
    .verifycode_itemtwo{
        justify-content: space-between;
    }
    .verifycode_itwoleft{
        width: 4.0rem;
        height: 1.166667rem;
    }
    .verifycode_itwoleft input{
        display: block;
        width: 100%;
        height: 1.1rem;
        outline: none;
        border: none;
        font-size: 0.388889rem;
        font-weight: 500;
        color: #1A1A1A;
        background: #ffffff;
        padding-left: 0;
    }
    .verifycode_itworight{
        width: auto;
        height: 0.75rem;
        background: #00CA88;
        border-radius: 0.75rem;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        padding: 0 0.13rem;
    }
    .verifycode_itworight.active{
        background: #CFCFCF;
    }
    .verifycode_itworight #sendcode{
        width: auto;
        min-width: 2.4rem;
        display: block;
        height: auto;
        font-size: 12px;
        font-weight: 400;
        color: #FFFFFF;
        outline: none;
        border: none;
        margin: 0 auto;
        background: #00CA88;
    }
    .verifycode_itworight #sendcode.active{
        background: #CFCFCF;
    }
    .verifycode_iwarn_scale-1px{
        position: relative;
        border:none;
    }
    .verifycode_iwarn_scale-1px:after{
        content: '';
        position: absolute;
        bottom: 0;
        background: #DB861F;
        width: 100%;
        height: 1px;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
    }
    .verifycode_fwran_view{
        width: 100%;
        height: auto;
        padding-top: 0.388889rem;
        font-size: 0.388889rem;
        font-weight: 500;
        color: #DB861F;
    }
    .verifycode_google_wrap{
        width: 100%;
        height: 2.388889rem;
        display: flex;
        justify-content: center;
    }
    .verifycode_google_cont{
        width: 7.305556rem;
        height: 1.944444rem;
        margin: 0 auto;
    }
    .verifycode_footer_btns{
        width: 100%;
        height: 1.666667rem;
    }
    .verifycode_footer_btn{
        width: 91.11%;
        height: 1.222222rem;
        margin: auto;
    }
    .verifycode_footer_xys{
        width: 100%;
        height: auto;
        display: flex;
        justify-content: center;
        padding-bottom: 0.555556rem;
    }
    .verifycode_footer_xy{
        font-size: 14px;
        transform: scale(0.79);
        font-weight: 400;
        color: #00CA88;
    }
    .verifycode_footer_xy span{
        text-decoration: underline;
    }
    .eshoy_slider_btn_label{
        width: 4.722222rem;
        height: 1.194444rem;
        position: absolute;
        right: 0;
        top: -0.89rem;
    }
    .eshoy_slider_btn_label img{
        display: block;
        width: 4.722222rem;
        height: 1.194444rem;
    }
</style>

<style less>
    .hide{
        display: none!important;
    }
    .potato_loading{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 9999999;
    }
    .potato_loading_zhe{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        background-color: rgba(0,0,0,0.6);
        opacity: 0;
        transition: opacity 0.4s ease;
    }
    .potato_loading_zhe_tr{
        opacity: 1!important;
    }
    .potato_loading1{
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        opacity: 0;
        transition: opacity 0.4s ease;
    }
    .potato_loading1_Icon {
        width: 40px;
        height: 40px;
        margin: 0;
        background: transparent;
        border-top: 3px solid #9FB5DE;
        border-right: 3px solid transparent;
        border-radius: 50%;
        -webkit-animation: 1s spin linear infinite;
        animation: 1s spin linear infinite;
    }
    .potato_loading1_title{
        font-size: 14px;
        color: #9FB5DE;
    }
    .potato_loading3_title{
        display: inline-block;
        padding: 10px 14px;
        border-radius: 10px;
        background-color: rgba(0,0,0,0.8);
        color: #fff;
        max-width: 80%;
        line-height: 0.44rem;
    }
    @keyframes spin{
        from {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        to {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

    input::-webkit-input-placeholder {
        /* WebKit browsers，webkit内核浏览器 */
        color: #CFCFCF;
        font-size: 12px;
    }
    input:-moz-placeholder {
        color: #CFCFCF;
        font-size: 12px;
    }
    input::-moz-placeholder {
        color: #CFCFCF;
        font-size: 12px;
    }
    input:-ms-input-placeholder {
        color: #CFCFCF;
        font-size: 12px;
    }

    .audithome_tps .van-notice-bar{
        height: 0.833333rem;
        background-color: rgba(0,0,0,0);
        color: #FFFFFF;
    }
    .van-slider__bar{
        background: linear-gradient(353deg, #19A95C 0%, #3DE189 100%);
    }
    .van-slider__button{
        width: 25px !important;
        height: 25px !important;
        background: url(../../assets/img/sliderBtn.png) top center no-repeat;
        background-size: cover;
        cursor: pointer;
        border: none !important;
        background-color: transparent !important;
        top: -27px !important;
    }
    .van-popup--right{
        border-radius: 0.555556rem 0px 0px 0.555556rem;
    }
    .kychome_slider_title_one .van-checkbox__icon{
        width: 12px;
        height: 12px;
    }
    .kychome_slider_title_one .van-checkbox__label{
        font-size: 12px;
    }
</style>